export const xmlDownload = ({ xml, fileName }) => {
  const url = window.URL.createObjectURL(new window.Blob([xml]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName + '.xml')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
